import { Component, Input, OnChanges, OnInit } from "@angular/core";

@Component({
    selector: "ngx-guided-tour-steps-bullet",
    templateUrl: "./ngx-guided-tour-steps-bullet.component.html",
    styleUrls: ["./ngx-guided-tour-steps-bullet.component.scss"],
})
export class GuidedTourStepsBulletComponent implements OnChanges {
    @Input() total = 0;
    @Input() set actived(value: number) {
        this.stepActived = value - 1;
    }
    stepActived = 0;
    bullets: Array<number> = [];

    ngOnChanges(): void {
        this.bullets = Array.from(Array(this.total).keys());
    }
}
